(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[746],{

/***/ 1671:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/faq",
      function () {
        return __webpack_require__(5094);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 3193:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _HomeUI_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7274);
/* harmony import */ var _HomeUI_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_HomeUI_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _constants_metaConstants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7202);
// Modules



// Styles

// Constants

var Footer = function() {
    var items = [
        {
            label: "FAQ",
            route: "/faq"
        },
        {
            label: "Contact Us",
            route: "/contact-us"
        },
        {
            label: "Privacy Policy",
            route: "/privacy-policy"
        },
        {
            label: "Terms of Service",
            route: "/terms-of-service"
        }
    ];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_HomeUI_module_scss__WEBPACK_IMPORTED_MODULE_4___default().footerWrapper),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "pagePad__x",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_HomeUI_module_scss__WEBPACK_IMPORTED_MODULE_4___default().footer),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex--1",
                            style: {
                                maxWidth: 360
                            },
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                    href: "/",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                        className: "cursor--pointer",
                                        src: "/assets/icons/logoFull.svg?v=2",
                                        alt: "NamasPay logo",
                                        style: {
                                            height: 32
                                        }
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                    className: "fontSize--h4 color--secondary marginTop--l3",
                                    style: {
                                        lineHeight: 1.5
                                    },
                                    children: _constants_metaConstants__WEBPACK_IMPORTED_MODULE_3__/* .META_INFO.LONG_DESC */ .f.LONG_DESC
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "flex--1 padLeft--l2",
                            style: {
                                maxWidth: 420,
                                color: "rgba(246, 246, 246, 1)"
                            },
                            children: items === null || items === void 0 ? void 0 : items.map(function(item, index) {
                                /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                                    href: item === null || item === void 0 ? void 0 : item.route,
                                    target: "_blank",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                        className: "cursor--pointer display--block color--link ".concat(index > 0 ? "marginTop--l3" : "", " ").concat((_HomeUI_module_scss__WEBPACK_IMPORTED_MODULE_4___default().footerLink)),
                                        children: item === null || item === void 0 ? void 0 : item.label
                                    })
                                }, index);
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    style: {
                        height: 1,
                        background: "rgba(255,255,255,0.1)",
                        marginTop: 80,
                        marginBottom: 80
                    }
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "text__align--center color--secondary fontSize--h5 marginTop--l10",
                    children: "\xa9 Copyright 2023 Triotech Ltd"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "text__align--center color--secondary fontSize--h5 marginTop--l1",
                    children: "All rights reserved"
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Footer);


/***/ }),

/***/ 9533:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _HomeUI_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7274);
/* harmony import */ var _HomeUI_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_HomeUI_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _elements_CTA__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1461);
/* harmony import */ var _utils_helperFunctions__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8365);
// Modules



// Styles

// Components

// Utils

var Header = function() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isBrowser = ref[0], setIsBrowser = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (true) setIsBrowser(true);
    }, []);
    var isDesktop = function() {
        if (!isBrowser) return true;
        var isMobile = "ontouchstart" in window; // likely mobile
        return !isMobile;
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_HomeUI_module_scss__WEBPACK_IMPORTED_MODULE_5___default().headerWrapper),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "".concat((_HomeUI_module_scss__WEBPACK_IMPORTED_MODULE_5___default().header), " pagePad__x"),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                    href: "/",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        className: "cursor--pointer",
                        src: "/assets/icons/logoFullBlack.svg",
                        alt: "NamasPay logo",
                        style: {
                            height: 56,
                            width: 296
                        }
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_elements_CTA__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    className: (_HomeUI_module_scss__WEBPACK_IMPORTED_MODULE_5___default().downloadCTA),
                    type: "primary",
                    text: isDesktop() ? "Download Now" : "Download Now",
                    onAction: _utils_helperFunctions__WEBPACK_IMPORTED_MODULE_4__/* .onDownloadClick */ .No
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Header);


/***/ }),

/***/ 1010:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _HomeUI_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(7274);
/* harmony import */ var _HomeUI_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_HomeUI_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _elements_CTA__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1461);
/* harmony import */ var _utils_helperFunctions__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8365);
/* harmony import */ var _constants_metaConstants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(7202);
// Modules


// Styles

// Components

// Utils & Constants


var SupportSection = function() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isBrowser = ref[0], setIsBrowser = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (true) setIsBrowser(true);
    }, []);
    var isDesktop = function() {
        if (!isBrowser) return true;
        var isMobile = "ontouchstart" in window; // likely mobile
        return !isMobile;
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_HomeUI_module_scss__WEBPACK_IMPORTED_MODULE_5___default().supportContainer),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "sectionHeading textAlign--center--mobile flex--1",
                children: [
                    "We’re here",
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                    "to help, 24x7"
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "".concat((_HomeUI_module_scss__WEBPACK_IMPORTED_MODULE_5___default().details), " flex--1"),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_HomeUI_module_scss__WEBPACK_IMPORTED_MODULE_5___default().desc),
                    children: [
                        "Got questions? Our support team is available via chat or call anytime you need. Reach out to us at ",
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            href: "mailto:".concat(_constants_metaConstants__WEBPACK_IMPORTED_MODULE_4__/* .META_INFO.EMAIL */ .f.EMAIL),
                            rel: "noreferrer",
                            style: {
                                color: "blue"
                            },
                            children: _constants_metaConstants__WEBPACK_IMPORTED_MODULE_4__/* .META_INFO.EMAIL */ .f.EMAIL
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SupportSection);


/***/ }),

/***/ 368:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ allFAQs; }
/* harmony export */ });
var allFAQs = [
    {
        title: "Who can use NamasPay?",
        desc: "NamasPay is open to travellers from around the world. Currently, NamasPay can be used by citizens from the following countries:<br/><br/>\n                Argentina, Australia, Brazil, Canada, China, France, Germany, India, Indonesia, Italy, Japan, Mexico, Republic of Korea, Russia, Saudi Arabia, South Africa, T\xfcrkiye, United Kingdom (UK), United States of America (USA), European Union (EU) and African Union (AU)."
    },
    {
        title: "Is my country in European Union?",
        desc: "NamasPay can be used by citizens of following European Union countries:<br/><br/>\n                Austria, Belgium, Bulgaria, Croatia, Republic of Cyprus, Czech Republic, Denmark, Estonia, Finland, France, Germany, Greece, Hungary, Ireland, Italy, Latvia, Lithuania, Luxembourg, Malta, Netherlands, Poland, Portugal, Romania, Slovakia, Slovenia, Spain and Sweden."
    },
    {
        title: "Is my country covered in African Union?",
        desc: "NamasPay can be used by citizens of following African Union countries:<br/><br/>\n                Algeria, Angola, Benin, Botswana, Burkina Faso, Burundi, Cameroon, Cape Verde, Central Africa, Chad, Comoros, Congo, Democratic Republic of the Congo, Djibouti, Egypt, Equatorial Guinea, Eritrea, Eswatini, Ethiopia, Gabon, Gambia, Ghana, Guinea, Guinea-Bissau, Ivory Coast, Kenya, Lesotho, Liberia, Libya, Madagascar, Malawi, Mali, Mauritania, Mauritius, Morocco, Mozambique, Namibia, Niger, Nigeria, Rwanda, Sao Tome and Principe, Senegal, Seychelles, Sierra Leone, Somalia, South Africa, South Sudan, Sudan, Tanzania, Togo, Tunisia, Uganda, Western Sahara, Zambia, Zimbabwe."
    },
    {
        title: "Is NamasPay secure?",
        desc: "NamasPay focuses on the safety and security of your money by strictly adhering to regulatory guidelines by RBI &  NPCI. With NamasPay’s digital payments, not only do you get convenience, but you also avoid the risk of losing your cash or cards. Every transaction you make is device-lock protected. The app also constantly checks for fraudulent activity, thereby ensuring your money is safe within the app and while making payments."
    },
    {
        title: "What documents are required to set up my NamasPay wallet?",
        desc: "To set up your NamasPay wallet, you will be made to complete a physical verification which will require your passport and Visa."
    },
    {
        title: "Where can I spend with NamasPay?",
        desc: "Cabs, restaurants, online shopping, hotels, malls - you name it, NamasPay will help you pay it! Pay any merchant UPI ID with NamasPay while you travel across the country."
    },
    {
        title: "What are NamasPay's charges?",
        desc: "Here are all the charges that come with NamasPay - nothing more, nothing less.<br/><br/>\n                - One time set-up fee of INR ~1650<br/><br/>\n                - ~4% of your amount every time you add money<br/><br/>\n                - ~1% of your amount when you withdraw money"
    },
    {
        title: "How do I add money into my NamasPay wallet?",
        desc: "You can add money into your NamasPay wallet from any Mastercard or Visa card! Once entered in your currency, the money shall get added and stored as Rupees in your wallet, which you can then spend anywhere in India."
    },
    {
        title: "Can I deposit cash to add money into my NamasPay wallet?",
        desc: "We currently do not accept cash deposits to add money into your wallet. However, you can use any Mastercard or Visa card to transfer money into your wallet instead!"
    },
    {
        title: "How do you Scan and Pay?",
        desc: "With Scan and Pay, you can make a payment by simply scanning a merchant's QR code and entering the amount you would like to send!<br/><br/>\n                Here's how you can Scan and Pay:<br/><br/>\n                - Open your NamasPay app and click on 'Scan & Pay'<br/><br/>\n                - A scanner opens up, with which you can scan any merchant's QR code<br/><br/>\n                - Once scanned, enter the amount you wish to send to the merchant and click 'Pay'<br/><br/>\n                - That's it! You just made a payment using Scan and Pay."
    },
    {
        title: "How do you pay using your UPI ID?",
        desc: "On NamasPay, you can make payments online using your UPI ID! Here's how it works:<br/><br/>\n                - Once you reach the payments screen of the app or website you are shopping on, click on the 'Add new UPI ID' option while choosing your mode of payment<br/><br/>\n                - Enter your UPI ID, which can be copied from the home screen of your NamasPay app<br/><br/>\n                - Once entered, you can proceed to pay<br/><br/>\n                - You will then receive a request for the payment on your NamasPay app<br/><br/>\n                - Accept the payment request by clicking on 'Pay', and you're done!"
    }
];


/***/ }),

/***/ 1461:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1799);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _CTA_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(653);
/* harmony import */ var _CTA_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_CTA_module_scss__WEBPACK_IMPORTED_MODULE_2__);
// Modules



// Styles

var CTA = function(param) {
    var className = param.className, type = param.type, leftImg = param.leftImg, text = param.text, rightImg = param.rightImg, onAction = param.onAction, disabled = param.disabled, style = param.style;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "".concat(className || "", " ").concat((_CTA_module_scss__WEBPACK_IMPORTED_MODULE_2___default().customCta), " ").concat((_CTA_module_scss__WEBPACK_IMPORTED_MODULE_2___default())[type] || "", " ").concat(disabled ? (_CTA_module_scss__WEBPACK_IMPORTED_MODULE_2___default().disabled) : ""),
        style: style ? (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, style) : {},
        onClick: function() {
            if (onAction) onAction();
        },
        children: [
            leftImg,
            text,
            rightImg
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CTA);


/***/ }),

/***/ 5094:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Faq; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./components/HomeUI.module.scss
var HomeUI_module = __webpack_require__(7274);
var HomeUI_module_default = /*#__PURE__*/__webpack_require__.n(HomeUI_module);
// EXTERNAL MODULE: ./components/Header.js
var Header = __webpack_require__(9533);
// EXTERNAL MODULE: ./components/Footer.js
var Footer = __webpack_require__(3193);
// EXTERNAL MODULE: ./components/SupportSection.js
var SupportSection = __webpack_require__(1010);
// EXTERNAL MODULE: ./constants/faqConstants.js
var faqConstants = __webpack_require__(368);
;// CONCATENATED MODULE: ./components/FaqUI.js
// Modules


// Styles

// Components



// Constants

var FaqUI = function() {
    var ref = (0,react.useState)(0), openedFaqIndex = ref[0], setOpenedFaqIndex = ref[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
        className: "main",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Header/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "pagePad__x padTop--l5 padBottom--l8",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        id: "faq",
                        className: "sectionHeading text__align--center",
                        children: "FAQs"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "marginTop--l4",
                        children: faqConstants/* allFAQs.map */.o.map(function(item, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "".concat((HomeUI_module_default()).faqWidget, " ").concat(index > 0 ? "marginTop--l3" : ""),
                                onClick: function() {
                                    return setOpenedFaqIndex(index === openedFaqIndex ? -1 : index);
                                },
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "display--flex flex__justifyContent--between flex__alignItems--center cursor--pointer",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                className: (HomeUI_module_default()).desc,
                                                children: item.title
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: "/assets/icons/downArrow.svg",
                                                alt: "Down arrow icon",
                                                style: {
                                                    rotate: index === openedFaqIndex ? "180deg" : "0deg",
                                                    marginLeft: 8
                                                }
                                            })
                                        ]
                                    }),
                                    index === openedFaqIndex && /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        className: "".concat((HomeUI_module_default()).desc, " marginTop--l4 padTop--l4"),
                                        style: {
                                            borderTop: "1px solid rgba(0,0,0,0.05)",
                                            color: "#7c7c7c"
                                        },
                                        dangerouslySetInnerHTML: {
                                            __html: item.desc
                                        }
                                    })
                                ]
                            }, index);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "marginTop--l12",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SupportSection/* default */.Z, {})
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer/* default */.Z, {})
        ]
    });
};
/* harmony default export */ var components_FaqUI = (FaqUI);

// EXTERNAL MODULE: ./constants/metaConstants.js
var metaConstants = __webpack_require__(7202);
;// CONCATENATED MODULE: ./pages/faq.js
// Libraries




// Components

// Constants & Utils


var faqMainEntity = [];
faqConstants/* allFAQs */.o === null || faqConstants/* allFAQs */.o === void 0 ? void 0 : faqConstants/* allFAQs.forEach */.o.forEach(function(item) {
    faqMainEntity.push({
        "questionName": item === null || item === void 0 ? void 0 : item.title,
        "acceptedAnswerText": item === null || item === void 0 ? void 0 : item.desc
    });
});
function Faq() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        content: metaConstants/* META_INFO.FAQ_PAGE_TITLE */.f.FAQ_PAGE_TITLE,
                        name: "twitter:title"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        content: metaConstants/* META_INFO.FAQ_PAGE_URL */.f.FAQ_PAGE_URL,
                        name: "twitter:url"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
                title: metaConstants/* META_INFO.FAQ_PAGE_TITLE */.f.FAQ_PAGE_TITLE,
                canonical: metaConstants/* META_INFO.FAQ_PAGE_URL */.f.FAQ_PAGE_URL,
                openGraph: {
                    title: metaConstants/* META_INFO.FAQ_PAGE_TITLE */.f.FAQ_PAGE_TITLE,
                    url: metaConstants/* META_INFO.FAQ_PAGE_URL */.f.FAQ_PAGE_URL
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* FAQPageJsonLd */.Mg, {
                mainEntity: faqMainEntity
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_FaqUI, {})
        ]
    });
};


/***/ }),

/***/ 7274:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"headerWrapper":"HomeUI_headerWrapper___nauh","header":"HomeUI_header__yQ7P7","downloadCTA":"HomeUI_downloadCTA__LNsRz","title":"HomeUI_title__2YcTz","desc":"HomeUI_desc__q_oUd","sec3Wrapper":"HomeUI_sec3Wrapper___igt3","sec3":"HomeUI_sec3__kotDB","comparisonContainer":"HomeUI_comparisonContainer__BnBHn","comparisonRow":"HomeUI_comparisonRow__HWCvn","col1":"HomeUI_col1__NPcZA","sec1":"HomeUI_sec1__Udx3W","details":"HomeUI_details__zHmRo","pageTitle":"HomeUI_pageTitle__DblKZ","storeImagesWrapper":"HomeUI_storeImagesWrapper__AsT_K","storeImg":"HomeUI_storeImg__cwF9n","img":"HomeUI_img__wr61b","sec2Wrapper":"HomeUI_sec2Wrapper__9F0Dp","sec2":"HomeUI_sec2__1oD_8","flagsAnimationContainer":"HomeUI_flagsAnimationContainer__0iL4g","flagsAnimation":"HomeUI_flagsAnimation__MI930","run":"HomeUI_run__zEBA4","welcomeToText":"HomeUI_welcomeToText__MPG2m","usageWidgetRow":"HomeUI_usageWidgetRow__r_9xq","usageWidget":"HomeUI_usageWidget__qhtob","upiFeaturesContainerWrapper":"HomeUI_upiFeaturesContainerWrapper__LdAM_","upiFeaturesContainer":"HomeUI_upiFeaturesContainer__6huwu","upiFeatureWidget":"HomeUI_upiFeatureWidget__f6AJt","featureImg":"HomeUI_featureImg__jkEbn","col2":"HomeUI_col2__3VpYf","col3":"HomeUI_col3__f3C0n","col4":"HomeUI_col4__KtU6j","safeMoneyContainer":"HomeUI_safeMoneyContainer__rKH36","sec4Wrapper":"HomeUI_sec4Wrapper__8p5Nc","sec4":"HomeUI_sec4__UNs6M","sectionHeading":"HomeUI_sectionHeading__v0wV_","imgsWrapper":"HomeUI_imgsWrapper__KCJXg","sec5Wrapper":"HomeUI_sec5Wrapper__ZSYE6","sec5":"HomeUI_sec5__ySaqh","sec5Widget":"HomeUI_sec5Widget__WubTd","imgWrapper":"HomeUI_imgWrapper__dWwzu","acrossCountryListWrapper":"HomeUI_acrossCountryListWrapper__NLWtP","acrossCountryList":"HomeUI_acrossCountryList__bwW1q","acrossCountryRun":"HomeUI_acrossCountryRun__JmtHx","sec6Wrapper":"HomeUI_sec6Wrapper__XXxDI","sec6":"HomeUI_sec6__IAkGG","widget":"HomeUI_widget__hLe1m","faqWrapper":"HomeUI_faqWrapper__8yi6e","faqContainer":"HomeUI_faqContainer__muFWf","faqWidget":"HomeUI_faqWidget__BIPpQ","supportContainer":"HomeUI_supportContainer__LUmWB","footerWrapper":"HomeUI_footerWrapper__Xa_Rg","footer":"HomeUI_footer__wvlfA","footerLink":"HomeUI_footerLink__HLbvS"};

/***/ }),

/***/ 653:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"customCta":"CTA_customCta__k8Ay7","secondary":"CTA_secondary__hCi_W"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [664,774,888,179], function() { return __webpack_exec__(1671); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);